import '../vendor/jquery.modal'
import '../vendor/jquery.tooltip'

let core = {
    init() {
        this.initModals()
        this.initTooltips()
    },

    initModals() {
        $('.js-modal').modal()
    },

    initTooltips() {
        if (!Modernizr.touchevents) {
            $('.js-tooltip').tooltip()
        }
    }
}

export default core